// ** Initial State
const initialState = {
  allData: [],
  allUsers: [],
  data: [],
  userProfileUpdateView:[],
  total: 1,
  params: {},
  selectedUser: null,
  userProfile: null,
  userRegistration: null,
  userProfileAdminView: null,
  adminViewUser: null,
  ea: null,
  allRegisteredUser: {
    "limit": 30,
    "page": 0,
    "total_pages": null,
    "total_records": null,
    "data": null
  },
  allRegisteredAttendee: {
    "limit": 30,
    "page": 1,
    "total_pages": null,
    "total_records": null,
    "data": null
  },
  attendeePublicView: null,
  pageLoader:true,
  password: null,
  testUserData: 'inactive'
}

const users = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_ALL_DATA':
      return { ...state, allData: action.data }

    case 'GET_ALL_DATA_ADMIN':
      return {
        ...state,
        allUsers: action.data
      }

    case 'GET_DATA':
      return {
        ...state,
        data: action.data,
        allData: action.data
      }

    case 'ADD_DATA':
      return {
        ...state,
        allData: [...state.allData, action.data]
      }

    case 'UPDATE_DATA':
      return {
        ...state,
        userProfile: action.data
      }
    case 'UPDATE_DATA_ADMIN':
      return {
        ...state,
        userProfileAdminView: action.data
      }

    case 'UPDATE_DATA_ADMIN_TWO':
      return {
        ...state,
        userProfileUpdateView: action.data
      }
    case 'DELETE_DATA':
      return {
        ...state,
        allData: [...state.allData, action.data]
        // allData: state.map(allData => {
        //   if (allData.id === action.payload) {
        //     return { ...allData, complete: false };
        //   } 
        // })
      }
    case 'GET_USER':
      return {
        ...state,
        selectedUser: action.selectedUser
      }

    case 'GET_ADMIN_USER':
      return {
        ...state,
        adminUser: action.adminuser
      }

    case 'GET_DATA_ADMIN':
      return {
        ...state,
        userProfileAdminView: action.data
      }


    case 'CURRENT_USER':
      return {
        ...state,
        userProfile: action.data
      }
    case 'SET_CURRENT_USER':
      return {
        ...state,
        userProfile: action.data
      }
    case 'CURRENT_USER_EMPTY':
      return {
        ...state,
        userProfile: null
      }

    case 'CURRENT_REG_USER':
      return {
        ...state,
        userRegistration: action.data
      }
    case 'SET_CURRENT_REG_USER':
      return {
        ...state,
        userRegistration: action.data
      }
    case 'UPDATE_REG_USER':
      return {
        ...state,
        userRegistration: action.data
      }
    case 'USER_LIST':
      return {
        ...state,
        allRegisteredUser: action.data, pageLoader: false
      }
    case 'TEST_USER_DATA':
      return {
        ...state,
        testUserData: action.data
      }
    case 'ATTENDEE_LIST':
      return {
        ...state,
        allRegisteredAttendee: action.data, pageLoader: false
      }
    case 'UPDATE_ATTENDEE_PUBLIC_VIEW':
      return {
        ...state,
        attendeePublicView: null
      }
    case "CHANGE_USER_PASSWORD":
      return { ...state, password: action.data };
    case 'PAGE_LOADER':
      return { ...state, pageLoader: action.data }
    default:
      return { ...state }
  }
}
export default users
